import moment from 'moment';
import { ReleaseItem } from '../../../types/release.type';
import Container from '../../containers/container';
import AlbumImage from '../../images/album.image';
import { VStack } from '../../layouts/stack.layout';
import Card from '../card';

const styles = {
  container: 'p-3 justify-items-stretch relative rounded-xl overflow-hidden',
  body: 'flex justify-between z-10 relative gap-2',
  'release-card-details': 'justify-between release-card-details laptop:py-4',
  overlay:
    'z-10 absolute top-0 left-0 w-full h-full bg-black/20 backdrop-blur-lg rounded-xl',
  label: 'font-text uppercase mobile:text-lg tablet-lg:text-xl text-gray-100',
  'label-2':
    'font-text uppercase mobile:text-2xl tablet-lg:text-3xl text-primary font-semibold',
  'label-3':
    'font-text uppercase mobile:text-base tablet-lg:text-lg text-primary font-semibold w-full text-ellipsis overflow-hidden whitespace-nowrap',
};

type Props = {
  onClick: Function;
  data: ReleaseItem;
};

export default function ReleaseCard({ onClick, data }: Props) {
  return (
    <Card
      onClick={() => onClick(data)}
      backgroundImage={data.cover}
      className={styles.container}
    >
      <Card.Header>
        <Container extensions={styles.overlay} />
      </Card.Header>
      <Card.Body className={styles.body}>
        <VStack extensions={styles['release-card-details']}>
          <VStack extensions="w-full">
            <div className={styles.label}>
              {moment(data.date).format('MMM')}
            </div>
            <div className={styles['label-2']}>
              {moment(data.date).format('DD')}
            </div>
          </VStack>
          <VStack extensions="w-full">
            <div className={styles.label}>{data.artist.name}</div>
            <div className={styles['label-3']}>{data.title}</div>
          </VStack>
        </VStack>
        <AlbumImage
          className="release-card-img"
          src={data.cover}
          alt={data.title}
        />
      </Card.Body>
    </Card>
  );
}
